export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".btn-menu");
    const arrowButtonHTML = `
    <button class="arrow-button">
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.66667 8.41664L9.83333 12.5833L14 8.41664" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>`;

    const DUR = 400;

    function getEnv() {
        const winWidth = $(window).width();
        return {
            winWidth,
            isTouch: body.hasClass('touch'),
            isNoTouch: body.hasClass('no-touch')
        };
    }

    function showSecondColumn($li) {
        const {winWidth, isNoTouch} = getEnv();
        if (!(winWidth > 1200 && isNoTouch)) return;

        const $columns = $li.closest('.columns');
        const $secondCol = $columns.find('.column').eq(1);
        const $submenu = $li.find('> .inner > .wrap > .submenu-second-level');
        if (!$submenu.length || !$secondCol.length) return;

        const submenuId = $submenu.data('submenu-id') || ('ss-' + Math.random().toString(36).substr(2, 9));
        $submenu.attr('data-submenu-id', submenuId);
        removeClone($secondCol);
        const $clone = createClone($submenu, submenuId);
        animateClone($secondCol, $clone);
    }

    function showThirdColumn($li) {
        const {winWidth, isNoTouch} = getEnv();
        if (!(winWidth > 1200 && isNoTouch)) return;

        const $columns = $li.closest('.columns');
        const $thirdCol = $columns.find('.column').eq(2);
        const $feature = $thirdCol.find('.features-grid-item');

        const img = $li.data('image') || '';
        const title = $li.data('title') || '';
        const text = $li.data('text') || '';

        if (!img && !title && !text) {
            $feature.css({opacity: 0, transform: 'translateY(10px)', transition: `opacity ${DUR}ms ease-in-out, transform ${DUR}ms ease-in-out`});
            return;
        }


        $feature.css({opacity: 0, transform: 'translateY(10px)', transition: `opacity ${DUR/2}ms ease-in-out, transform ${DUR/2}ms ease-in-out`});

        setTimeout(() => {
            if (img) {
                $feature.find('.features-grid-image').removeClass('hide').find('img').attr('src', img);
            } else {
                $feature.find('.features-grid-image').addClass('hide');
            }
            $feature.find('.features-grid-info strong.h6').text(title);
            $feature.find('.features-grid-info p').text(text);

            requestAnimationFrame(() => {
                $feature.css({opacity: 1, transform: 'translateY(0)', transition: `opacity ${DUR/2}ms ease-in-out, transform ${DUR/2}ms ease-in-out`});
            });
        }, DUR/2);
    }



    function createClone($src, submenuId) {
        return $src.clone()
            .removeAttr('style')
            .addClass('submenu-clone')
            .attr('data-submenu-id', submenuId)
            .css({
                display: 'block',
                opacity: 0,
                transform: 'translateY(-10px)',
                transition: `opacity ${DUR}ms ease-in-out, transform ${DUR}ms ease-in-out`,
                willChange: 'opacity, transform'
            });
    }

    function animateClone($col, $clone) {
        $col.empty().append($clone);
        setTimeout(() => $clone.css({opacity: 1, transform: 'translateY(0)'}), 20);
    }

    function removeClone($col) {
        const $old = $col.find('.submenu-clone');
        if ($old.length) {
            $old.css({opacity: 0, transform: 'translateY(10px)'});
            setTimeout(() => $old.remove(), DUR);
        }
    }

    $(".main-menu").each((i, menu) => {
        const $nav = $(menu);
        const itemsWithSub = $nav.find(".menu-item-has-children");

        itemsWithSub.each((i, item) => {
            const $item = $(item);
            const $subMenu = $item.find("> .sub-menu");
            const $subMenuSecondLevel = $item.find(" > .inner .wrap .submenu-second-level");
            if (!$item.find("> .arrow-button").length) {
                $subMenu.before(arrowButtonHTML);
                $subMenuSecondLevel.before(arrowButtonHTML);
                $subMenuSecondLevel.prev(".arrow-button").addClass("second-level");
            }
        });
    });

    $('.main-menu .columns').on('mouseleave', function () {
        const $columns = $(this);
        const $thirdCol = $columns.find('.column').eq(2);

        $thirdCol.find('.submenu-clone').remove();

        const $feature = $thirdCol.find('.features-grid-item');
        $feature.css({opacity: 0, transform: 'translateY(10px)', transition: 'opacity 400ms ease, transform 400ms ease'});
        $feature.find('.features-grid-image').removeClass('hide').find('img').attr('src', '');
        $feature.find('strong.h6').text('');
        $feature.find('p').text('');
    });


    $(document).on('mouseenter', '.columns > .column:first-child .sub-menu-list li', function () {
        showSecondColumn($(this));
        showThirdColumn($(this));
    });

    $(document).on('mouseenter', '.columns > .column:nth-child(2) .sub-menu-list li', function () {
        showThirdColumn($(this));
    });

    $(document).on('click', '.columns > .column:first-child .sub-menu-list li', function () {
        const {winWidth, isTouch} = getEnv();
        if (winWidth <= 1200 || isTouch) return;
        showSecondColumn($(this));
        showThirdColumn($(this));
    });

    $(document).on("click", function (e) {
        const $target = $(e.target);
        const isDesktop = window.innerWidth > 1199;
        const isTouch = body.hasClass("touch");

        if ($target.closest(btnMenu).length) {
            e.preventDefault();
            body.toggleClass("menu-opened");
            return;
        }

        if ($target.closest(".arrow-button:not(.second-level)").length) {
            const $arrow = $target.closest(".arrow-button");
            const $menuItem = $arrow.closest(".menu-item-has-children");

            const openEffect = isDesktop && isTouch ? "fadeIn" : "slideDown";
            const closeEffect = isDesktop && isTouch ? "fadeOut" : "slideUp";

            if (!$menuItem.hasClass("active")) {
                $(".main-menu .menu-item-has-children.active")
                    .removeClass("active")
                    .find(".sub-menu")[closeEffect]();

                $menuItem.addClass("active").find("> .sub-menu")[openEffect]();
            } else {
                $menuItem.removeClass("active").find("> .sub-menu")[closeEffect]();
            }

            return;
        }

        if ($target.closest(".arrow-button.second-level").length) {
            const $arrow = $target.closest(".arrow-button");
            const $menuItem = $arrow.next(".submenu-second-level");

            const openEffect = isDesktop && isTouch ? "fadeIn" : "slideDown";
            const closeEffect = isDesktop && isTouch ? "fadeOut" : "slideUp";

            if (!$menuItem.hasClass("active")) {
                $(".main-menu .menu-item-has-children .inner.active")
                    .removeClass("active")[closeEffect]();

                $menuItem.addClass("active")[openEffect]();
            } else {
                $menuItem.removeClass("active")[closeEffect]();
            }

            return;
        }

        if (!$target.closest(".main-menu").length) {
            $(".main-menu .menu-item-has-children.active")
                .removeClass("active");
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js